import React from 'react';
import { Building2, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function AdminRedirect() {
  // Production URL for when deployed
  const prodUrl = 'admin.zenstudios.in';
  // Preview URL (current environment) - uses relative path
  const previewUrl = `/api/admin-portal`;
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-md text-center">
        <div className="w-20 h-20 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-amber-500/20">
          <Building2 className="w-10 h-10 text-white" />
        </div>
        
        <h1 className="text-3xl font-bold text-white mb-2">
          <span className="text-white">Zen</span>
          <span className="text-amber-500">Studios</span>
        </h1>
        
        <h2 className="text-xl text-slate-300 mb-4">Admin Portal</h2>
        
        <p className="text-slate-400 mb-8">
          The Admin Dashboard has been moved to a secure, dedicated application for enhanced security and better performance.
        </p>
        
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6 mb-6">
          <p className="text-slate-300 text-sm mb-2">Production URL:</p>
          <p className="text-amber-400 font-mono text-lg mb-4">{prodUrl}</p>
          <p className="text-slate-400 text-xs">Preview environment available below</p>
        </div>
        
        <div className="flex flex-col gap-3">
          <Button 
            className="w-full bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700"
            onClick={() => window.open(previewUrl, '_blank')}
          >
            Open Admin Portal <ExternalLink className="w-4 h-4 ml-2" />
          </Button>
        </div>
        
        <p className="text-slate-500 text-sm mt-6">
          For security reasons, internal applications are hosted separately.
        </p>
      </div>
    </div>
  );
}
